import {TextFieldProps} from '@mui/material';
import {DateTimePicker, LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import {useEffect, useMemo, useRef, useState} from 'react';

interface Props {
  label?: string;
  value?: Date | null;
  maxDate?: Date | null;
  disabled?: boolean;
  renderInput?: Omit<TextFieldProps, 'variant'>;
  onChange?: (value: Date | null) => any;
  onAccept?: (value: Date | null) => any;
}

export const DateTimeSelect = ({
  label,
  value,
  maxDate,
  disabled,
  renderInput,
  onChange,
  onAccept,
}: Props) => {
  const date = useMemo(() => (value ? dayjs(value) : null), [value]);
  const dateRef = useRef(date);
  const [tmpDate, setTmpDate] = useState(date);

  useEffect(() => {
    setTmpDate(date);
    dateRef.current = date;
  }, [date]);

  const [open, setOptn] = useState(false);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateTimePicker
        open={open}
        value={tmpDate}
        label={label}
        disabled={disabled}
        format="YYYY-MM-DD HH:mm:ss"
        closeOnSelect={false}
        views={['year', 'month', 'day', 'hours', 'minutes', 'seconds']}
        timeSteps={{minutes: 1, seconds: 1}}
        slotProps={{
          textField: {
            ...renderInput,
            inputProps: {
              readOnly: true,
            },
            onClick: () => setOptn(true),
          },
          actionBar: {
            actions: ['accept', 'cancel'],
          },
        }}
        maxDate={maxDate ? dayjs(maxDate) : null}
        onChange={(v) => {
          onChange?.(v?.toDate() ?? null);
          setTmpDate(v);
          setTimeout(() => {
            setTmpDate(dateRef.current);
          });
        }}
        onAccept={(v) => {
          onAccept?.(v?.toDate() ?? null);
        }}
        onClose={() => setOptn(false)}
      />
    </LocalizationProvider>
  );
};
